/* @ngInject */
function ErrorInterceptor($q, $injector, $filter) {
  return {
    responseError: function (rejection) {
      // Show error when 5xx
      const $state = $injector.get("$state");
      if (rejection.status >= 500 && rejection.status < 600) {
        if (rejection.status !== 503 && rejection.data !== "Unsplash service temporary unavailable") {
          const Notification = $injector.get("Notification");
          Notification.error({
            title: $filter("trans")("errorInterceptor.error.generic.title"),
            message: $filter("trans")("errorInterceptor.error.generic.message"),
          });
        }
      } else if (
        rejection.status === 400 &&
        !$state.is("app.costsLibrary") &&
        rejection.data.includes("validation error")
      ) {
        const Notification = $injector.get("Notification");
        Notification.error({
          title: $filter("trans")("errorInterceptor.error.generic.title"),
          message: $filter("trans")("errorInterceptor.error.lastChanges.message"),
        });
      }

      return $q.reject(rejection);
    },
  };
}

export default ErrorInterceptor;
